const url = window.location.hostname;
export const translation = {
  zenit: {
    en: {
      siteTitle: "Lucky Zeros",
      rulesBtnText: "Rules",
      title: ``,
      title1: 'Lucky Zeros',
      subtitle: "November 21 to December 31 we insure you and your bets against boring soccer",
      button: "START",
      stepTitle1: 'STEP 1',
      stepText1: 'Click the Participate button',
      step1Span2: ' under the bet slip on the site',
      stepTitle2: 'STEP 2',
      stepText2: `Place a single bet on the\xA0
      exact score. except 0-0`,
      stepTitle3: 'STEP 3',
      stepText3: `Get a free bet if there         
        are no goals in the game`,
      stepText1Mobile: 'Browse to the storis and click ',
      step1Span2Mobile: 'the PARTICIPATE button',
      stepText2Mobile: `Bet on the exact score, \xA0
      except 0-0`,
      stepText3Mobile: `Get a free bet if there are        
        no goals in the game`,
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "SUPPORT SERVICE:",
      supportSpan: "8(800)222-22-12",
      rulesHeaderText: {
        main: "Terms and conditions of the Promotion\u00A0",
        span: "Lucky Zeros"
      },
      paragraph1: '1. The Promotion «Lucky Zeros» runs from 11/21/2022 to 12/31/2022',
      paragraph2: '2. The terms of the Promotion are set by Zenit betting company and can be changed at any time without giving any reasons or additional notifications.',
      paragraph31: '3. A participant must register or log in on the ' ,
      paragraph3url: ` ${url},`,
      paragraph32: ' website during the period of the Promotion and confirm his/her participation in the Promotion by clicking on the "Participate" button.',
      paragraph4: '4. Refunds are credited in the form of a free bet.',
      paragraph5: `5. Free bet accrual conditions:`,
      paragraph6: '6. The minimum bet amount is 3$',
      paragraph7: '7. The maximum amount of the freebet - 80$.',
      paragraph8: '8. Bonuses are not credited in the following cases:',
      paragraph9: '9. BC Zenit has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company\'s Promotions, invalidate any actions of a participant in respect of whom BC Zenit has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:',
      paragraph10: '10. In case of detection of any of the violations of the rules of the Promotion, BC Zenit has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.',
      paragraph11: '11. Terms of use of free bets:',
      paragraph12: '12. In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      paragraph13: '13. Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      paragraph14: '14. By using the free bet option, the Participant fully agrees to these Terms and conditions.',
      tableLeftTopText: 'minimum deposit amount',
      tableCenterTopText: 'maximum deposit amount',
      tableRightTopText:  'currency',
      subParagraph51: "5.1 Single soccer bets made on any exact score, except 0:0, participate in the Promotion. ",
      subParagraph52: "5.2 If the match on which the single bet was made ends with the score 0:0, the player's account is credited with a refund in the form of a free bet equivalent to the amount of the bet made.",
      subParagraph53: "5.3 Free bets are awarded daily from 00:00 to 03:00 UTC+3.",
      subParagraph81: "8.1. A bet is made on a match or event not covered by the Promotion.",
      subParagraph82: "8.2. The bet was made using the free bet.",
      subParagraph83: "8.3 The bet was sold by the participant of the Action. ",
      subParagraph91: "a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for BC Zenit and for other participants and for third parties;",
      subParagraph92: "b) in case of revealing the fact that the participant has provided information that does not correspond to reality;",
      subParagraph93: "c) the Participant has violated the Terms and conditions of the Promotion;",
      subParagraph94: "d) the Participant has violated the gambling rules and/or any other rules in effect;",
      subParagraph95: "e) the Participant's account has been blocked.",
      subParagraph111: "11.1. The free bet can be used after being checked for compliance with the requirements specified in Clause 5 of these Terms and conditions within 7 days.",
      subParagraph112: "11.2. The free bet was made only for the entire amount of the free bet."
    },
    ru: {
      siteTitle: "Щедрые нули",
      rulesBtnText: "Правила",
      title: ``,
      title1: 'Щедрые нули',
      subtitle: "С 21 ноября по 31 декабря страхуем твои ставки от скучного футбола",
      button: "НАЧАТЬ",
      stepTitle1: 'ШАГ 1',
      stepText1: 'Перейди на сайт и нажми кнопку',
      step1Span2: ' УЧАСТВОВАТЬ под корзиной',
      stepTitle2: 'ШАГ 2',
      stepText2: `Сделай ставку на точный\xA0
      счёт, кроме 0:0`,
      stepTitle3: 'ШАГ 3',
      stepText3: `Получи фрибет, если        
        в игре не будет голов`,
      stepText1Mobile: 'Перейди в сторис и нажми ',
      step1Span2Mobile: 'кнопку УЧАСТВОВАТЬ',
      stepText2Mobile: `Сделай ставку на точный\xA0
      счёт, кроме 0:0`,
      stepText3Mobile: `Получи фрибет, если        
        в игре не будет голов`,
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "СЛУЖБА ПОДДЕРЖКИ:",
      supportSpan: "8(800)222-22-12",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Щедрые нули"
      },
      paragraph1: '1. Акция «Щедрые нули» проводится с 21.11.2022 г. по 31.12.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph31: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте ' ,
      paragraph3url: ` ${url},`,
      paragraph32: 'а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Возврат начисляется в виде фрибета',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Минимальная сумма ставки — 200 рублей.',
      paragraph7: '7. Максимальная сумма фрибета — 5000 рублей.',
      paragraph8: '8. Бонусы не начисляются в следующих случаях:',
      paragraph9: '9. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph10: '10. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph11: '11. Условия использования фрибетов:',
      paragraph12: '12. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph13: '13. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph14: '14. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимальная сумма депозита',
      tableCenterTopText: 'максимальная сумма депозита',
      tableRightTopText:  'валюта',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: "5.1 В Акции участвуют одиночные ставки на футбол, сделанные на любой точный счёт, кроме 0:0. ",
      subParagraph52: "5.2 Если матч, на который была сделана одиночная ставка, заканчивается со счётом 0:0, на счёт игрока зачисляется возврат в виде фрибета эквивалентного сумме совершенной ставки. ",
      subParagraph53: "5.3 Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3",
      subParagraph81: "8.1. Ставка сделана на матч или событие не из условий Акции.",
      subParagraph82: "8.2. Ставка сделана с использованием бесплатной ставки",
      subParagraph83: "8.3 Ставка была продана участником Акции.",
      subParagraph91: "а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;",
      subParagraph92: "б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;",
      subParagraph93: "в) участник нарушает Правила Акции;",
      subParagraph94: "г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;",
      subParagraph95: "д) аккаунт участника Акции заблокирован.",
      subParagraph111: "11.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.",
      subParagraph112: "11.2. Совершить бесплатную ставку можно только на всю сумму фрибета."
    },
  },
  cupis: {
    ru: {
      siteTitle: "Щедрые нули",
      rulesBtnText: "Правила",
      title: ``,
      title1: 'Щедрые нули',
      subtitle: "С 21 ноября по 31 декабря страхуем твои ставки от скучного футбола",
      button: "НАЧАТЬ",
      stepTitle1: 'ШАГ 1',
      stepText1: 'Перейди на сайт и нажми кнопку',
      step1Span2: ' УЧАСТВОВАТЬ под корзиной',
      stepTitle2: 'ШАГ 2',
      stepText2: `Сделай ставку на точный\xA0
      счёт, кроме 0:0`,
      stepTitle3: 'ШАГ 3',
      stepText3: `Получи фрибет, если        
        в игре не будет голов`,
      stepText1Mobile: 'Перейди в сторис и нажми ',
      step1Span2Mobile: 'кнопку УЧАСТВОВАТЬ',
      stepText2Mobile: `Сделай ставку на точный\xA0
      счёт, кроме 0:0`,
      stepText3Mobile: `Получи фрибет, если        
        в игре не будет голов`,
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "СЛУЖБА ПОДДЕРЖКИ:",
      supportSpan: "8(800)222-55-50",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Щедрые нули"
      },
      paragraph1: '1. Акция «Щедрые нули» проводится с 21.11.2022 г. по 31.12.2022 г. ',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph31: '3. Участнику Акции необходимо в период проведения Акции зарегистрироваться или авторизоваться на сайте ' ,
      paragraph3url: ` ${url},`,
      paragraph32: ' а также обязательно подтвердить свое участие в Акции нажатием на кнопку «Участвовать».',
      paragraph4: '4. Возврат начисляется в виде фрибета',
      paragraph5: '5. Условия начисления фрибета (бесплатной ставки):',
      paragraph6: '6. Минимальная сумма ставки — 200 рублей.',
      paragraph7: '7. Максимальная сумма фрибета — 5000 рублей.',
      paragraph8: '8. Бонусы не начисляются в следующих случаях:',
      paragraph9: '9. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph10: '10. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph11: '11. Условия использования фрибетов:',
      paragraph12: '12. В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      paragraph13: '13. Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      paragraph14: '14. Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      tableLeftTopText: 'минимальная сумма депозита',
      tableCenterTopText: 'максимальная сумма депозита',
      tableRightTopText:  'валюта',
      tableCurrencyRUB: 'рубль',
      tableCurrencyUSD: 'доллар',
      tableCurrencyEUR: 'евро',
      tableCurrencyUAH: 'гривна',
      tableCurrencyKZT: 'тенге',
      tableCurrencyPRB: 'руб. ПМР',
      tableCurrencyIRR: 'иранский риал',
      tableCurrencyBRL: 'бразильский реал',
      tableCurrencyTMT: 'туркменский манат',
      tableCurrencyMDL: 'молдавский лей',
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph51: "5.1 В Акции участвуют одиночные ставки на футбол, сделанные на любой точный счёт, кроме 0:0. ",
      subParagraph52: "5.2 Если матч, на который была сделана одиночная ставка, заканчивается со счётом 0:0, на счёт игрока зачисляется возврат в виде фрибета эквивалентного сумме совершенной ставки. ",
      subParagraph53: "5.3 Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3",
      subParagraph81: "8.1. Ставка сделана на матч или событие не из условий Акции.",
      subParagraph82: "8.2. Ставка сделана с использованием бесплатной ставки",
      subParagraph83: "8.3 Ставка была продана участником Акции.",
      subParagraph91: "а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;",
      subParagraph92: "б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;",
      subParagraph93: "в) участник нарушает Правила Акции;",
      subParagraph94: "г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;",
      subParagraph95: "д) аккаунт участника Акции заблокирован.",
      subParagraph111: "11.1. Фрибет может быть использован после проверки соответствия условиям, указанным в п. 5 настоящих Правил, в течение 7 дней.",
      subParagraph112: "11.2. Совершить бесплатную ставку можно только на всю сумму фрибета."
    },
  }
}

